import { useCallback, useRef } from "react";

/**
 * Hook: distinguish real navigation and React Strict Mode remount
 * @param key navigation identifier
 * @param thresholdMs Time threshold in milliseconds
 */
export const useRealNavigation = (key?: string, thresholdMs = 300) => {
  const mountTimeRef = useRef<number>(performance.now());
  const lastKeyRef = useRef<string | null>(key || null);

  const checkIsRealNavigation = useCallback(() => {
    const currentTime = performance.now();
    console.log("time diff:", currentTime - mountTimeRef.current);

    //navigate to another url
    if (key && key !== lastKeyRef.current) {
      lastKeyRef.current = key;
      mountTimeRef.current = currentTime;
      return true;
    }

    //time check
    if (
      mountTimeRef.current &&
      currentTime - mountTimeRef.current > thresholdMs
    ) {
      mountTimeRef.current = currentTime;
      return true;
    }

    return false;
  }, [key, thresholdMs]);

  return {
    checkIsRealNavigation,
    lastMountTime: mountTimeRef.current,
    getTimeSinceMount: () => performance.now() - mountTimeRef.current,
  };
};
